import React from 'react';
import { graphql, useFragment } from 'react-relay';
import { useIntl } from '@atlassian/jira-intl';
import type { ResolutionGroupHeader$key } from '@atlassian/jira-relay/src/__generated__/ResolutionGroupHeader.graphql';
import { TextGroupHeaderContent } from '../../../../common/text-group-header-content/index.tsx';
import messages from './messages.tsx';

export type Props = {
	resolutionGroupHeader: ResolutionGroupHeader$key | null;
};

export const ResolutionGroupHeader = ({ resolutionGroupHeader }: Props) => {
	const data = useFragment<ResolutionGroupHeader$key>(
		graphql`
			fragment ResolutionGroupHeader on JiraJqlResolutionFieldValue {
				displayName
				resolution {
					id
					name
				}
			}
		`,
		resolutionGroupHeader,
	);

	const { formatMessage } = useIntl();

	return (
		<TextGroupHeaderContent
			text={data?.displayName || data?.resolution?.name || data?.resolution?.id}
			noValueText={formatMessage(messages.noResolution)}
		/>
	);
};
